import './CritCell.scss';
import React from 'react';
import Tooltip from '@srm/ui/tooltip';
import { MdInfoOutline } from 'react-icons/md';
import { ITableDemandItem, ITableDemandSettings } from '@models/winnerSelection/ITableDemand';
import { getEffectiveCritType } from '../utils/ratingScales';
import { ScaleBadge } from './ScaleBadge';

interface IProps {
    crit: ITableDemandItem;
    settings: ITableDemandSettings | undefined;
}

/**
 * Sticky-left ячейка критерия:
 * - название с info-иконкой для информационных критериев;
 * - бейджи (вес + шкала) для score-критериев.
 *
 * settings нужен для customScaleCrits / ratingScaleHints в ScaleBadge.
 */
export const CritCell: React.FC<IProps> = ({ crit, settings }) => {
    const effType = getEffectiveCritType(crit);
    const isInfo = effType === 'info';
    const isScore = effType === 'score';
    const isCustomScale = settings?.customScaleCrits?.includes(crit.critName) ?? false;
    const scaleKey = crit.ratingScale ?? '';
    const customScaleHint = isCustomScale ? settings?.ratingScaleHints?.[crit.ratingScale] : undefined;

    return (
        <div className="ws-crit">
            <div className="ws-crit__title">
                {crit.critName}
                {isInfo ? (
                    <Tooltip
                        openDelay={100}
                        background="black"
                        position="bottom"
                        label="Информационный критерий — без оценки, только комментарий."
                    >
                        <span className="ws-crit__info-icon">
                            <MdInfoOutline size="14px" />
                        </span>
                    </Tooltip>
                ) : null}
            </div>
            {isScore && (
                <div className="ws-crit__badges">
                    {crit.critWeight != null && (
                        <span className="ws-crit__badge ws-crit__badge--weight">
                            вес
                            <b>{crit.critWeight.toLocaleString('ru-RU', { maximumFractionDigits: 4 })}</b>
                        </span>
                    )}
                    <ScaleBadge scaleKey={scaleKey} isCustomScale={isCustomScale} customScaleHint={customScaleHint} />
                </div>
            )}
        </div>
    );
};
